<template>
<div class="hotelGoods_ui">
    <div class="container content-box">
        <div class="option">
            <div class="option-boxs">
                <div class="option-box" @click="isShowLayer('city')" v-if="curChooseInfo.city==''||curChooseInfo.city=='all'">
                    <div class="option-box-top">
                        <i class="iconfont iconweizhi"></i>
                        <div class="choose" v-if="curChooseInfo.city==''">选择地区</div>
                        <div class="choose" v-else>{{curChooseInfo.cityDesc}}</div>
                    </div>
                    <div class="num">共<b>{{areaInfo.length-1}}</b>个城市</div>
                </div>
                <div class="option-box option-select" @click="isShowLayer('city')" v-else>
                    <i class="iconfont iconweizhi"></i>
                    <div class="choose">{{curChooseInfo.cityDesc}}</div>
                </div>
                <div class="option-box option-box-flex" @click="isShowLayer('hotel')" v-if="curChooseInfo.hotelCode==''||curChooseInfo.hotelCode=='all'">
                    <div class="option-box-top">
                        <i class="iconfont iconjiudianweixuanzhong"></i>
                        <div class="choose" v-if="curChooseInfo.hotelCode==''">选择酒店</div>
                        <div class="choose" v-else>{{curChooseInfo.hotelName}}</div>
                    </div>
                    <div class="num">共<b>{{hotelList.length-1}}</b>个酒店</div>
                </div>
                <div class="option-box option-select option-box-flex" @click="isShowLayer('hotel')" v-else>
                    <i class="iconfont iconjiudianweixuanzhong"></i>
                    <div class="choose">{{curChooseInfo.hotelName}}</div>
                </div>
            </div>
			 <div class="goods-num">
				共计产品
				<p><b>{{totalRows}}</b>款</p>
			</div>
        </div>
        <goodsList class="goodsList" :goodsListData="goodsList"></goodsList>
        <div class="more-goods">
            <div class="btn" @click="goType()">点击查看更多 <i class="icongengduo1 iconfont"></i></div>
        </div>
        <!-- <div class="welcome">— 绿云提供运营和技术支持 —</div> -->
    </div>
    <div class="choose-layer" :class="{'choose-layer-active':isLayer.isShowCity}">
        <div class="choose-layer-box">
            <div class="tl">— 请选择城市 —</div>
            <div class="list">
                <div class="item" v-for="(item,i) in areaInfo" :key="i" @click="chooseCity(item)" :class="{'active':curChooseInfo.city==item.code}">
                    <i class="iconfont iconweizhi"></i>{{item.descript}}
                    <i class="iconfont icongouhao"></i>
                </div>
            </div>
            <div class="btn" @click="closeLayer('city')">
                <div class="btn-box">确 定</div>
            </div>
        </div>
    </div>
    <div class="choose-layer" :class="{'choose-layer-active':isLayer.isShowHotel}">
        <div class="choose-layer-box">
            <div class="tl">— 请选择<b>{{curChooseInfo.cityDesc}}</b>门店 —</div>
            <div class="list">
                <div class="item big-item" v-for="(item,i) in hotelList" :key="i" @click="chooseHotel(item)" :class="{'active':curChooseInfo.hotelCode==item.code}">
                    <i class="iconfont iconjiudianweixuanzhong"></i>{{item.descript}}
                    <i class="iconfont icongouhao"></i>
                </div>
            </div>
            <div class="btn" @click="closeLayer('hotel')">
                <div class="btn-box">确 定</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from "@/utils/api";
import {
    setStorage,
    getStorage
} from "@/utils/wxuser";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import {
    urlEncode,
    createUrl
} from "@/utils/index";
import goodsList from "@/components/goodsList";

var config = {};
export default {
    data() {
        return {
            user: '',
            wxuser: '',
            hotelCode: 0,
            isTips: false,
            goodsDatas: {
                hotelGroupCode: config.hotelGroupCode,
                equipment: "desktop",
                appid: config.appid,
                hotelCode: config.hotelCode,
                firstResult: 0,
                pageSize: 20,
                orderCondition: "listOrder",
                orderDirection: "desc",
                domain: '',
                channel: 'mini_app',
                shopChannel: 'normal',
            },

            goodsList: [],
            areaInfo: [],
            hotelList: [],
            curChooseInfo: {
                city: '',
                hotelCode: '',
                cityDesc: '',
                hotelName: ''
            },
            isLayer: {
                isShowCity: false,
                isShowHotel: false
            },
            totalRows: 0,

        };
    },

    methods: {



        sureEvent() {
            this.isTips = !this.isTips
        },

        isShowLayer(val) {
            if (val == 'city') {
                this.isLayer.isShowCity = true
                if (this.curChooseInfo.city == '') {
                    this.curChooseInfo.city = this.areaInfo[0].code
                    this.curChooseInfo.cityDesc = this.areaInfo[0].descript
                }
            }
            if (val == 'hotel') {
                if (this.curChooseInfo.city == '') {
                    jAlert3('请先选择城市')
                    return false
                }
                this.isLayer.isShowHotel = true
                if (this.curChooseInfo.hotelCode == '') {
                    this.curChooseInfo.hotelCode = this.hotelList[0].code
                    this.curChooseInfo.hotelName = this.hotelList[0].descript
                }
            }
        },
        closeLayer(val) {
            if (val == 'city') {
                this.isLayer.isShowCity = false
                this.findHotelByCondition(this.curChooseInfo.city)
            }
            if (val == 'hotel') {
                this.isLayer.isShowHotel = false
                this.getGoodsList()
            }
        },
        chooseHotel(item) {
            this.curChooseInfo.hotelCode = item.code
            this.curChooseInfo.hotelName = item.descript

        },
        chooseCity(item) {
            this.curChooseInfo.city = item.code
            this.curChooseInfo.cityDesc = item.descript
        },
        findHotelByCondition(code) {
            var _this = this
            var opt = {
                hotelGroupCodes: config.hotelGroupCode,
                otaChannel: "WECHAT",
            }
            if (code && code != 'all') {
                opt.city = code
            }
            var reselect = false
            if (this.curChooseInfo.hotelCode != '') {
                reselect = true
            }
            this.curChooseInfo.hotelCode = ''
            this.curChooseInfo.hotelName = ''
            api.findHotelByCondition(opt).then(res => {
                if (res.result == 1) {
                    if (res.retVal.resultCode == 0) {
                        this.hotelList = []
                        this.hotelList[0] = {
                            descript: '全部门店',
                            code: 'all'
                        }
                        res.retVal.resultInfos.forEach((item, i) => {
                            this.hotelList.push(item)
                        })
                        if (reselect) {
                            this.chooseHotel(this.hotelList[0])
                            this.closeLayer('hotel')
                        }
                    }
                }
            })

        },
        getAreaInfo() {
            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                sortType: 'asc',

            };
            api.getAreaInfo(opt).then(res => {
                if (res.result == 1) {
                    this.areaInfo.push({
                        'code': 'all',
                        'descript': '全部区域'
                    })
                    for (var i in res.retVal) {
                        res.retVal[i].forEach((item) => {
                            this.areaInfo.push(item)
                        })
                    }

                } else {
                    jAlert3(res.msg);
                }
            })
        },

        goType() {
            let query ={}
            if(this.curChooseInfo.hotelCode){
                query.hotelCode = this.curChooseInfo.hotelCode
                query.city = this.curChooseInfo.city
            }
            this.$router.push({
                path: "/typeList",
                query:query

            });
        },
 
        getGoodsList() {
            this.goodsList = []
            var opt = JSON.parse(JSON.stringify(this.goodsDatas))
            opt.cityHotelCode = ''
            if (this.curChooseInfo.city != '') {
                if (this.curChooseInfo.hotelCode == 'all') {
                    var hotelCode = []
                    this.hotelList.forEach((item, i) => {
                        if (i !== 0) {
                            hotelCode.push(item.code)
                        }
                    })
                    opt.hotelCode = 0
                    opt.cityHotelCode = hotelCode.join(',')
                } else {

                    opt.belongHotelCode = this.curChooseInfo.hotelCode
                }
            }
            if (this.user && this.user.memberId) {
                this.getCurrentCard();
                var chuzhiIndex = getStorage("cardIndex") || 0;
                opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            }
             if(getStorage('levelCode')){
                opt.cardCode = getStorage('levelCode')
            }
            api.listGoods(opt).then(res => {
                if (res.result == 1) {
                    this.goodsList = res.retVal.datas
                    this.totalRows = res.retVal.totalRows
                    uni.stopPullDownRefresh()
                } else {
                    jAlert3(res.msg)
                }
            })
        },

    },

    created() {
        config = getStorage("config");
        this.user = getStorage('user');
        this.wxuser = getStorage('wxuser');
        this.hotelCode = config.hotelCode
        var base = {
            hotelGroupCode: config.hotelGroupCode,
            appid: config.appid,
            hotelCode: config.hotelCode,
            channel: config.channel,

        }

        this.goodsDatas = Object.assign(this.goodsDatas, base)
    },
    mounted() {
        this.getAreaInfo()
        this.findHotelByCondition()
        this.getGoodsList()

    },

    components: {
        goodsList,

    },

}
</script>

<style lang="less" scoped>
@import url("~@/styles/mixin.less");

.hotelGoods_ui {
    .content-box {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding: 0 0 0.532rem;
        margin-top: 0.266rem;

        .option {
            display: flex;
            align-items: center;
            justify-content: space-between;
			margin: 0.1862rem 0.4rem 0;
            padding-bottom: 0.1596rem;
            border-bottom: 1px solid #ECF0F2;

            .option-boxs {
                display: flex;
                flex: 1;

                .option-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-right: 0.2128rem;
                    box-sizing: border-box;
                    height: 1.2502rem;
                    padding: 0.2128rem 0.266rem 0.1596rem 0.266rem;
                    background: fff;
                    border-radius: 0.133rem;
                    border: 1px solid #ECF0F2;
                    flex: 1;

                    &.option-box-flex {
                        margin: 0;
                    }

                    &.option-select {
                        border: 0;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                        padding-left: 0.1862rem;
                        position: relative;
                        padding-right: 0.399rem;
                        min-width: none;
                        color: #2F3740;
                        font-weight: bold;
                        font-size: 14px;

                       

                        i {
                            color: #aaa;
                            margin-top: 0.0266rem;
                            font-size: 13px;
                            margin-right: 0.133rem;
                        }
                    }

                    .option-box-top {
                        display: flex;
                        align-items: center;
                        color: #2F3740;
                        font-weight: bold;
                        font-size: 14px;

                        i {
                            color: #aaa;
                            margin-top: 0.0266rem;
                            font-size: 12px;
                            margin-right: 0.133rem;
                        }

                        image {

                            height: 0.399rem;
                            width: 0.399rem;
                            margin-right: 0.0532rem;
                        }

                        .choose {
                            position: relative;

                            &:after {
                                content: '';
                                position: absolute;
                                right: -0.399rem;
                                top: 0.0798rem;
                                border-right: 0.0266rem solid #aaa;
                                border-bottom: 0.0266rem solid #aaa;
                                width: 0.1862rem;
                                height: 0.1862rem;
                                transform: rotate(45deg);
                            }
                        }
                    }

                    .num {

                        display: flex;
                        margin-left: 0.4522rem;
                        font-size: 12px;
                        line-height: 0.4522rem;

                        b {
                            color: @color-theme;
                            font-weight: bold;
                            font-size: 12px;

                        }
                    }

                }
            }

            .goods-num {
                font-size: 11px;
                color: #666666;
                min-width: 1.7556rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-end;

                p {
                    min-width: 1.7556rem;
                    display: flex;
                    justify-content: flex-end;

                    b {
                        color: @color-theme;
                        font-weight: bold;
                        margin-right: 0.133rem;
                    }
                }
            }
        }
    }

    .more-goods {
        display: flex;
        margin-top: 0.266667rem;
        justify-content: center;

        .btn {
            border-radius: 0.4256rem;
            border: 1px solid #F2F2F2;
            display: flex;
            height: 0.8512rem;
            padding: 0 0.5586rem;
            background: #fff;
            justify-content: center;
            align-items: center;
            color: @color-theme;
            font-size: 12px;

            i {
                color: @color-theme;
                font-size: 10px;
                margin-left: 0.1064rem;
            }
        }
    }

    .choose-layer {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 99;
        left: 0;
        top: -500%;
        opacity: 0;
        background: rgba(0, 0, 0, 0.5);
        transition: opacity .3s;

        &.choose-layer-active {
            opacity: 1;
            top: 0;
        }

        .choose-layer-box {
            padding: 0 0.4522rem 0;
            box-sizing: border-box;
            background: rgba(249, 250, 251, 1);
            border-radius: 0.266rem;
            width: 9.1238rem;
            position: absolute;
            top: 50%;
            left: 50%;

            max-height: 70%;
            overflow-y: scroll;
            transform: translate(-50%, -50%);

            .tl {
                position: sticky;
                top: 0;
                padding-top: 0.2128rem;
                background: rgba(249, 250, 251, 1);
                font-size: 12px;
                color: #666666;
                line-height: 0.798rem;
                display: flex;
                justify-content: center;

                b {
                    color: @color-theme;
                }
            }

            .list {

                display: flex;
                min-height: 4.655rem;
                flex-wrap: wrap;
                padding: 0.1862rem;
                max-height: 75%;
                background: #f9fafb;
                align-content: flex-start;
                justify-content: space-between;

                .item {
                    position: relative;
                    width: 3.6708rem;
                    height: 1.33rem;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 0px 0.399rem 0px rgba(24, 32, 111, 0.05);
                    border-radius: 0.1596rem;
                    display: flex;
                    align-items: center;
                    padding-left: 0.3192rem;
                    color: #111111;
                    font-weight: bold;
                    font-size: 14px;
                    margin: 0.2128rem 0;
                    box-sizing: border-box;

                    &.big-item {
                        width: 100%;
                        margin: 0.1064rem 0;
                    }

                    i.iconweizhi,
                    i.iconjiudianweixuanzhong {
                        color: @color-theme;
                        font-size: 12px;
                        margin-right: 0.1596rem;
                    }

                    i.icongouhao {
                        display: none;
                        position: absolute;
                        top: -0.0266rem;
                        right: -0.0266rem;
                        width: 0.7448rem;

                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-size: 9px;
                        height: 0.532rem;
                        background: @color-theme;
                        border-top-right-radius: 0.1596rem;
                        border-bottom-left-radius: 0.1596rem;
                    }

                    &.active {
                        border: 1px solid @color-theme;
                        box-shadow: none;

                        i.icongouhao {
                            display: flex;
                        }
                    }

                }
            }

            .btn {
                position: sticky;
                bottom: 0;
                padding-bottom: 0.6384rem;
                margin-top: 0.4256rem;
                width: 100%;
                height: 1.1172rem;
                background: rgba(249, 250, 251, 1);
				box-sizing: content-box;
                .btn-box {
                    width: 100%;
                    height: 1.1172rem;
                    background: @color-theme;
                    border-radius: 0.1596rem;
                    height: 1.1172rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
					
                    color: #FFFFFF;

                    font-size: 14px;
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/hotelGoods.vue